import { render, staticRenderFns } from "./StudentRecordings.vue?vue&type=template&id=7970a65b&scoped=true&"
import script from "./StudentRecordings.vue?vue&type=script&lang=js&"
export * from "./StudentRecordings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970a65b",
  null
  
)

export default component.exports